import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { ErrorBoundary } from '@/components';
import App from './App';

Sentry.init({
  // @ts-ignore
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: 'atlas-ui',
  integrations: [],
  tracesSampleRate: 0
});

// @ts-ignore
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={<ErrorBoundary />}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
